import type { FC } from "react";

import { ProgressBar } from "app/components/React/ProgressBar/ProgressBar";

import type { SearchTrafficData } from "../../types";
import CompoundWidget from "../CompoundWidget/CompoundWidget";
import KeywordsGraphChange from "../KeywordsGraphChange/KeywordsGraphChange";

import { ProgressBarWrapper } from "./styledComponents";

interface ProgressBarWidgetProps {
    data: SearchTrafficData;
    isKeywordsLoading: boolean;
    descriptionText: string;
}
const ProgressBarWidget: FC<ProgressBarWidgetProps> = ({ data, isKeywordsLoading, descriptionText }) => {
    return (
        <CompoundWidget>
            <CompoundWidget.Body
                data={data}
                descriptionText={descriptionText}
            >
                <ProgressBarWrapper>
                    <ProgressBar
                        width={data?.description?.numericValue}
                        height={8}
                    />
                </ProgressBarWrapper>
            </CompoundWidget.Body>
            <CompoundWidget.Footer>
                <KeywordsGraphChange
                    isLoading={isKeywordsLoading}
                    data={data?.keywordsData}
                />
            </CompoundWidget.Footer>
        </CompoundWidget>
    );
};

export default ProgressBarWidget;
